module.exports = __webpack_public_path__ + "static/media/appstore_icon.4abbca74.svg";